import React from "react";
import { func } from "prop-types";
import EllipsisButton from "@shared/EllipsisButton";

const EllipsisDropdown = ({ setToggleAddClientModal, setToggleAddCollaboratorModal, setToggleAddModal }) => (
  <div className="tw-absolute tw-rounded-md tw-overflow-hidden tw-shadow-modal tw-right-0 tw-top-[24px] tw-flex tw-flex-col tw-w-[200px]">
    <EllipsisButton onClick={() => setToggleAddClientModal(true)}>Client</EllipsisButton>
    <EllipsisButton onClick={() => setToggleAddCollaboratorModal(true)}>Collaborator</EllipsisButton>
    <EllipsisButton onClick={() => setToggleAddModal(true)}>Team Member</EllipsisButton>
  </div>
);

EllipsisDropdown.propTypes = {
  setToggleAddClientModal: func.isRequired,
  setToggleAddCollaboratorModal: func.isRequired,
  setToggleAddModal: func.isRequired,
};

export default EllipsisDropdown;
